export const paths = {
    VERIFY_PHONE: "/cusc/verifyphone",
    FORGOT_PASSWORD: "/cusc/fpwd-ini",
    CSL_MFA_FPD: "/cusc/fpwd-vsid",
}